<template>
  <div>

    <b-row class="my-3">
      <b-form-checkbox 
        class="col-12 ml-1" 
        v-model="nasales.active" 
        switch
      >
        Sintomas Nasales   
      </b-form-checkbox>

      <v-select
        v-if="nasales.active"
        class="col-12 mt-1"
        placeholder="Seleccione las alergias respiratorias"
        :options="nasalesOpts"
        :reduce="option => option"
        label="text"
        :multiple="true"
        taggable
        @input="newArray => nasales.selected = onAddNewOpt(newArray)"
      />
    </b-row>

    <hr>

    <b-row class="my-3">
      <b-form-checkbox 
        class="col-12 ml-1" 
        v-model="orofaringe.active" 
        switch
      >
        Síntomas relacionados con orofaringe, laringe.
      </b-form-checkbox>

      <v-select
        v-if="orofaringe.active"
        class="col-12 mt-1"
        placeholder="Seleccione las alergias respiratorias"
        :options="orofaringeOpts"
        :reduce="option => option"
        label="text"
        :multiple="true"
        taggable
        @input="newArray => orofaringe.selected = onAddNewOpt(newArray)"
      />
    </b-row>


    <hr>

    <b-row class="my-3">
      <b-form-checkbox 
        class="col-12 ml-1" 
        v-model="oticos.active"
        switch
      >
        Sintomas Oticos
      </b-form-checkbox>

      <v-select
        v-if="oticos.active"
        class="col-12 mt-1"
        placeholder="Seleccione las alergias respiratorias"
        :options="oticosOpts"
        :reduce="option => option"
        label="text"
        :multiple="true"
        taggable
        @input="newArray => oticos.selected = onAddNewOpt(newArray)"
      />
    </b-row>


  </div>
</template>

<script>

import vSelect from "vue-select";
import { addNewOpt } from '@/shared/helpers';

export default {

  name: "OtorrinoSintomas",

  components: {
    vSelect
  },

  data() {
    return {
      nasales: {
        active: false,
        selected: []
      },

      orofaringe:{
        active: false,
        selected: []
      },

      oticos:{
        active: false,
        selected: []
      },

      nasalesOpts: [
        { value: "congestion_nasal",                text: "Congestión (obstrucción) nasal" },
        { value: "congestion_alternante",           text: "Congestión nasal alternante" },
        { value: "congestion_predominio_derecho",   text: "Congestión nasal de predominio derecho" },
        { value: "congestion_predominio_izquierdo", text: "Congestión nasal de predominio izquierdo" },
        { value: "dificultad_respiratoria_nasal",   text: "Dificultad respiratoria nasal" },
        { value: "rinorrea",                        text: "Rinorrea" },
        { value: "ronquido",                        text: "Ronquido" },
        { value: "apnea",                           text: "Apnea" },
        { value: "prurito_nasal",                   text: "Prurito nasal" },
        { value: "resequedad_nasal",                text: "Resequedad nasal" },
        { value: "estornudo",                       text: "Estornudo" },
        { value: "dolor_molestia_nasal",            text: "Dolor o molestia nasal" },
        { value: "epistaxis_frecuente",             text: "Epistaxis (Sangrado nasal) frecuente" },
        { value: "epistaxis_esporadica",            text: "Epistaxis (Sangrado nasal) esporádica" },
        { value: "cefalea",                         text: "Cefalea" },
        { value: "hiposmia",                        text: "Trastorno o alteración del olfato: hiposmia" },
        { value: "anosmia",                         text: "Trastorno o alteración del olfato: anosmia" },
        { value: "parosmia",                        text: "Trastorno o alteración del olfato: parosmia" },
        { value: "fantosmia",                       text: "Trastorno o alteración del olfato: fantosmia" },
        { value: "malformacion_nasal",              text: "Malformación o deformidad en estructuras nasales" },
        { value: "cuerpo_extrano",                  text: "Cuerpo extraño" }
      ], 

      orofaringeOpts: [
        { value: "dolor_garganta",           text: "Dolor de garganta (Odinofagia)" },
        { value: "dificultad_deglucion",     text: "Dificultad para la deglución (disfagia)" },
        { value: "goteo_posterior",          text: "Goteo posterior" },
        { value: "carraspeo",                text: "Carraspeo" },
        { value: "sensacion_cuerpo_extrano", text: "Sensación de cuerpo extraño" },
        { value: "lesion_tumoracion",        text: "Lesión o tumoración" },
        { value: "ardor_prurito_orofaringe", text: "Ardor y prurito en orofaringe" },
        { value: "resequedad_garganta",      text: "Sensación de resequedad en garganta" },
        { value: "ronquido",                 text: "Ronquido" },
        { value: "alteracion_voz",           text: "Alteración de la voz: Disfonía, afonía" }
      ],

      oticosOpts:[
        { value: "otalgia_bilateral",             text: "Otalgia (dolor de oído) – bilateral" },
        { value: "otalgia_derecha",               text: "Otalgia (dolor de oído) – derecha" },
        { value: "otalgia_izquierda",             text: "Otalgia (dolor de oído) – izquierda" },
        { value: "otalgia_no_irradia",            text: "Otalgia (dolor de oído) – No se irradia" },
        { value: "otalgia_irradia",               text: "Otalgia (dolor de oído) – Que se irradia a:" },
        { value: "otorrea_bilateral",             text: "Otorrea (secreción ótica) – bilateral" },
        { value: "otorrea_derecha",               text: "Otorrea (secreción ótica) – derecha" },
        { value: "otorrea_izquierda",             text: "Otorrea (secreción ótica) – izquierda" },
        { value: "otorrea_color",                 text: "Otorrea (secreción ótica) – color:" },
        { value: "prurito_otico",                 text: "Prurito ótico" },
        { value: "malformacion_oreja",            text: "Malformación o deformidad en estructuras de oído" },
        { value: "sensacion_ocupacion_bilateral", text: "Sensación de ocupación en oído – bilateral" },
        { value: "sensacion_ocupacion_derecha",   text: "Sensación de ocupación en oído – derecha" },
        { value: "sensacion_ocupacion_izquierda", text: "Sensación de ocupación en oído – izquierda" },
        { value: "hipoacusia_bilateral",          text: "Pérdida o disminución de audición (hipoacusia) – bilateral" },
        { value: "hipoacusia_derecha",            text: "Pérdida o disminución de audición (hipoacusia) – derecha" },
        { value: "hipoacusia_izquierda",          text: "Pérdida o disminución de audición (hipoacusia) – izquierda" },
        { value: "cofosis_bilateral",             text: "Cofosis – bilateral" },
        { value: "cofosis_derecha",               text: "Cofosis – derecha" },
        { value: "cofosis_izquierda",             text: "Cofosis – izquierda" },
        { value: "mareo_frecuente",               text: "Mareo o vértigo – frecuente" },
        { value: "mareo_esporadico",              text: "Mareo o vértigo – esporádico" },
        { value: "mareo_cambio_posicion_si",      text: "Mareo o vértigo con relación al cambio de posición del cuerpo: SI" },
        { value: "mareo_cambio_posicion_no",      text: "Mareo o vértigo con relación al cambio de posición del cuerpo: NO" },
        { value: "cervicalgia",                   text: "Cervicalgia" },
        { value: "acufeno_bilateral",             text: "Percepción de zumbido (acufeno) – bilateral" },
        { value: "acufeno_derecha",               text: "Percepción de zumbido (acufeno) – derecha" },
        { value: "acufeno_izquierda",             text: "Percepción de zumbido (acufeno) – izquierda" },
        { value: "cuerpo_extrano",                text: "Cuerpo extraño" }
      ]
    }
  },

  methods: {
    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },
  },

  watch:{

    nasales:{
      deep: true,
      handler(newValue){
        this.$store.commit("setOtorrino", { nasales:newValue } );
      }
    },

    orofaringe:{
      deep: true,
      handler(newValue){
        this.$store.commit("setOtorrino", { orofaringe:newValue } );
      }
    },

    oticos:{
      deep:true,
      handler(newValue){
        this.$store.commit("setOtorrino", { oticos:newValue } );
      }
    }
  }
}
</script>
